<template>
  <!-- 开票信息 -->
  <div>
      <dialogModel
        title="代开一家"
        width="1200px"
        :visible.sync="dialogIssue"
        @handleClose="handleIssue"
        @handleOk="handleVerifyIssue"
      >
        <div class="main-body">
          <div class="Select-Con">
            <div
              v-for="(item, index) in SwitchArr"
              :key="index"
              class="Options"
              :class="Switch == item.id ? 'Select' : ''"
              :style="!SwitchIsItOptional ? 'cursor: not-allowed;' : ''"
              @click="SwitchIsItOptional ? handelSwitch(item.id) : null"
            >
              {{ item.name }}
            </div>
          </div>
        <el-form
          :model="from"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm invoice-info-form"
        >
          <div class="section-row">
          <div class="section-block section-buyer">
            <div class="section-title">购买方信息</div>
            <div v-if="Switch == 1">
              <el-form-item
                label="购买方企业："
                prop="Purchaser"
                :required="true"
                :errorType="'toast'"
              >
                <el-select
                  v-model="from.Purchaser"
                  placeholder="请选择需开票的企业"
                  filterable
                  @change="handelChange"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item.companyName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="统一社会信用代码："
                prop="PurchaserCode"
                :required="true"
              >
                <el-input
                  v-model="from.PurchaserCode"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="联系电话："
                prop="PurchaserPhone"
                :required="true"
              >
                <el-input
                  v-model="from.PurchaserPhone"
                  placeholder="请输入联系电话"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="开户银行名称："
                prop="PurchaseBankName"
                :required="false"
              >
                <el-input
                  v-model="from.PurchaseBankName"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="基本开户账号："
                prop="PurchaseAccount"
                :required="false"
              >
                <el-input
                  v-model="from.PurchaseAccount"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item prop="PurchaseAddress" class="is-hidden-item">
                <el-input v-model="from.PurchaseAddress" maxlength="30"></el-input>
              </el-form-item>

              <el-form-item label="是否展示：" required >
                <el-radio-group v-model="from.PurchaseShowHide">
                  <el-radio
                    v-for="item in ShowHideArr"
                    :key="'buy-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
                
              </el-form-item>
              <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所)
                </div>
            </div>

            <div v-if="Switch == 0">
              <el-form-item label="购买方：" prop="Purchaser" :required="true">
                <el-input
                  v-model="from.Purchaser"
                  placeholder="请输入购买方"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="身份证："
                prop="IdentityCard"
                :required="true"
              >
                <el-input
                  v-model="from.IdentityCard"
                  placeholder="请输入身份证"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系电话："
                prop="PurchaserPhone"
                :required="true"
              >
                <el-input
                  v-model="from.PurchaserPhone"
                  placeholder="请输入联系电话"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="开户银行名称："
                prop="PurchaseBankName"
                :required="false"
              >
                <el-input
                  v-model="from.PurchaseBankName"
                  placeholder="请输入开户银行名称"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="开户账号："
                prop="PurchaseAccount"
                :required="false"
              >
                <el-input
                  v-model="from.PurchaseAccount"
                  placeholder="请输入开户账号"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="地址："
                prop="PurchaseAddress"
                :required="true"
              >
                <el-input
                  v-model="from.PurchaseAddress"
                  placeholder="请输入地址"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否展示：" required >
                <el-radio-group v-model="from.PurchaseShowHide">
                  <el-radio
                    v-for="item in ShowHideArr"
                    :key="'buy0-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
                
              </el-form-item>
              <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所)
                </div>
            </div>
          </div>

          <div class="section-block section-seller">
            <div class="section-title">销售方信息</div>
            <el-form-item label="销售方：" required>
              <el-input :value="seller.sellerName" disabled maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" required>
              <el-input :value="seller.sellerCreditCode" disabled maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="法定代表人(负责人)：" required>
              <el-input :value="seller.sellerLegalPerson" disabled maxlength="30"></el-input>
            </el-form-item>
            <el-form-item
              label="企业类型："
              prop="EnterpriseType"
              :required="true"
            >
              <el-radio-group
                v-model="from.EnterpriseType"
                :disabled="!EnterpriseIsItOptional"
                @change="onEnterpriseTypeChange"
              >
                <el-radio
                  v-for="item in Arr"
                  :key="'et-' + item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="纳税类型："
              prop="PayTaxesType"
              :required="true"
            >
              <el-radio-group
                v-model="from.PayTaxesType"
                :disabled="!PayTaxesIsItOptional"
                @change="onPayTaxesTypeChange"
              >
                <el-radio
                  v-for="item in Arr1"
                  :key="'pt-' + item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item label="开户银行名称：" prop="bank" :required="false">
              <el-input
                v-model="from.bank"
                placeholder="请输入开户银行（支行）"
                maxlength="30"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="开户账号："
              prop="AccountNumber"
              :required="false"
            >
              <el-input
                v-model="from.AccountNumber"
                placeholder="请输入基本开户账号"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="住所："
              prop="address"
              :required="true"
            >
              <el-input
                v-model="from.address"
                placeholder="请输入住所"
                disabled
                maxlength="30"
              ></el-input>
            </el-form-item>
          </div>
          </div>

          <div class="section-block section-service">
            <div class="section-title">开票信息</div>
            <div class="Instruction">
              <el-form-item
                label="开票信息："
                prop="Message"
                :required="true"
              >
                <el-input
                  type="textarea"
                  class="textarea-lg"
                  placeholder="需按规定填写：项目名称、规则型号、单位单价（元）；可多填写"
                  v-model="from.Message"
                  :rows="5"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </div>

            <div class="invoice-meta-row">
              <el-form-item label="开票数量：" class="meta-item meta-quantity">
                <span class="quantity-text">{{ from.quantity }}张</span>
              </el-form-item>
              <el-form-item
                label="发票类型："
                prop="nature"
                :required="true"
                class="meta-item meta-nature"
              >
                <el-radio-group
                  v-model="from.nature"
                  @change="onNatureChange"
                >
                  <el-radio
                    v-for="item in radioList1"
                    :key="'nature-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="开票格式："
                prop="format"
                :required="true"
                class="meta-item meta-format"
              >
                <el-radio-group
                  v-model="from.format"
                  @change="onFormatChange"
                >
                  <el-radio
                    v-for="item in radioList"
                    :key="'fmt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>

            <div class="invoice-meta-row invoice-send-row">
              <el-form-item
                label="发送方式："
                prop="SendingMode"
                :required="true"
                class="meta-item meta-send"
              >
                <el-radio-group
                  v-model="from.SendingMode"
                  @change="onSendChange"
                >
                  <el-radio
                    v-for="item in radioList2"
                    :key="'send-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="需消耗："
                prop="numBean"
                class="meta-item meta-consume"
              >
                <div class="consume-text">
                  {{ from.numBean }}{{ from.numBean != "" ? "发票豆" : "" }}
                </div>
              </el-form-item>
            </div>

            <el-form-item
              label=" "
              prop="mailbox"
              :required="true"
              v-if="from.SendingMode == 2"
            >
              <el-input
                class="mailbox"
                v-model="from.mailbox"
                placeholder="请输入邮箱地址"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="reissueId"
              label="重开说明："
              prop="reissueReason"
              required
            >
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请填写重开说明"
                v-model="from.reissueReason"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
                v-model="from.Note"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
            
          </div>
        </el-form>
        </div>
      </dialogModel>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import VerificationPwd from "../IndexCom/VerificationPwd.vue"; //支付密码验证
import {
  companyInvoiceCalculatePrice, //计算代开发票需要消耗的发票豆
  pay, //支付接口
  getInvoiceDetail, //获取发票详情
} from "../../../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
export default {
  props: {
    dialogIssue: {},
    seller: {}, //销售方信息
    options: {}, //公司选择
    reissueId: {}, //重开发票ID
    reissueRow: {}, //重开发票的行数据
  },
  components: { VerificationPwd },
  data() {
    return {
      from: {
        Purchaser: "", //购买方
        PurchaserId: "", // 购买方id
        PurchaserName: "", //购买方法人
        PurchaserCode: "", //购买方统一代码
        IdentityCard: "", //身份证
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: "", //购买方企业类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址

        EnterpriseType: null, //企业类型
        PayTaxesType: null, //纳税类型
        bank: "", //开户行
        AccountNumber: "", //基本开户账号
        address: "", //住所
        phone: "", //固定电话
        PurchaseShowHide: 1, //购买方信息展示/隐藏
        SalesShowHide: 1, //销售方信息展示/隐藏
        Message: "", //开票信息
        quantity: "1", //开票数量
        nature: "0", //发票类型 0普票1专票
        format: "0", // 开票格式
        SendingMode: 2, // 发送方式
        mailbox: "", //邮箱地址
        Note: "", //备注
        reissueReason: "", //重开说明

        numBean: "",
      }, //填写的内容
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "购买方不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        IdentityCard: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
        PurchaserPhone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        // PurchaseBankName: [
        //   {
        //     required: true,
        //     message: "购买方开户银行名称不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        PurchaseAccount: [
          // {
          //   required: false,
          //   message: "购买方开户行账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        PurchaseAddress: [
          {
            required: true,
            message: "购买方地址不能为空",
            trigger: ["blur", "change"],
          },
        ],
        EnterpriseType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        // bank: [
        //   {
        //     required: true,
        //     message: "开户银行不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // AccountNumber: [
        //   {
        //     required: true,
        //     message: "开户账号不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        AccountNumber: [
          // {
          //   required: true,
          //   message: "开户账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "地址不能为空",
            trigger: ["blur", "change"],
          },
        ],
        // 销售方联系电话已按设计隐藏，仍随 seller 回填提交，不做表单必填校验
        // phone: [...],

        Message: [
          {
            min: 10,
            required: true,
            message: "请输入至少10字的开票信息",
            trigger: ["blur", "change"],
          },
        ],
        nature: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: ["blur", "change"],
          },
        ],
        format: [
          {
            required: true,
            message: "请选择开票格式",
            trigger: ["blur", "change"],
          },
        ],
        SendingMode: [
          { required: true, message: " ", trigger: ["blur", "change"] },
        ],
        mailbox: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
        ],
        
        reissueReason: [
          {
            validator: (rule, value, callback) => {
              if (!this.reissueId) {
                callback();
                return;
              }
              if (!value || !String(value).trim()) {
                callback(new Error("请填写重开说明"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      Arr: [
        { id: 0, name: "有限公司" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 1, name: "个体户" },
        { id: 4, name: "其它" },
      ], //企业类型
      Arr1: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型
      radioList1: [
        { name: "普票", id: "0" },
        { name: "专票", id: "1" },
      ], // 发票类型：普票/专票
      radioList: [
        { name: "PDF", id: "0" },
        { name: "JPG", id: "1" },
        { name: "OFD", id: "2" },
        { name: "XML", id: "3" },
      ], // 选择开票格式
      radioList2: [
        { name: "邮箱", id: 2 },
        { name: "企业微信", id: 3 },
      ], // 选择发送方式
      ShowHideArr: [
        { name: "展示", id: 1 },
        { name: "隐藏", id: 0 },
      ], //是否展示

      SwitchArr: [
        { id: 1, name: "开给企业" },
        { id: 0, name: "开给自然人" },
      ], //
      Switch: 1,
      VisiblePwd: false, //支付密码验证
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
      SwitchIsItOptional: true, //企业/自然人选择是否可选
    };
  },
  watch: {
    Switch: {
      handler(newSs, old) {
        // 清空from中某些数据的值（销售方信息不用清除）
      },
      immediate: false,
    },
    // 监听重开发票ID
    reissueId: {
      handler(newVal) {
        console.log('reissueId changed:', newVal, 'reissueRow:', this.reissueRow);
        if (newVal && this.reissueRow) {
          const detail = this.reissueRow;
          console.log('使用row数据回显:', detail);

          // 重新开票时回显数据
          this.Switch = detail.headType; // 0自然人 1企业
          this.SwitchIsItOptional = false; // 禁用企业/自然人选择

          if (this.Switch == 1) {
            // 企业
            this.from.Purchaser = detail.customerName || '';
            this.from.PurchaserCode = detail.customerCreditCode || '';
            this.from.PurchaserPhone = detail.customerPhone || '';
            this.from.PurchaseBankName = detail.customerBankName || '';
            this.from.PurchaseAccount = detail.customerBankAccount || '';
            this.from.PurchaseAddress = detail.customerCompanyAddress || '';
            this.from.PurchaseShowHide = detail.showCustomerInfo !== undefined ? detail.showCustomerInfo : 1;
          } else {
            // 自然人
            this.from.Purchaser = detail.customerName || '';
            this.from.IdentityCard = detail.customerCreditCode || '';
            this.from.PurchaserPhone = detail.customerPhone || '';
            this.from.PurchaseBankName = detail.customerBankName || '';
            this.from.PurchaseAccount = detail.customerBankAccount || '';
            this.from.PurchaseAddress = detail.customerCompanyAddress || '';
            this.from.PurchaseShowHide = detail.showCustomerInfo !== undefined ? detail.showCustomerInfo : 1;
          }

          // 回显销售方信息
          this.from.EnterpriseType = detail.sellerCompanyType !== undefined ? detail.sellerCompanyType : null;
          this.from.PayTaxesType = detail.sellerTaxType !== undefined ? detail.sellerTaxType : null;
          this.from.bank = detail.sellerBankName || '';
          this.from.AccountNumber = detail.sellerBankAccount || '';
          this.from.address = detail.sellerCompanyAddress || '';
          this.from.phone = detail.sellerPhone || '';
          this.from.SalesShowHide = detail.showSellerInfo !== undefined ? detail.showSellerInfo : 1;

          // 回显开票信息 - 直接从 detail 获取
          this.from.Message = detail.businessInfo || '';
          this.from.nature = detail.invoiceAttr !== undefined && detail.invoiceAttr !== '' ? String(detail.invoiceAttr) : '0';
          this.from.format = detail.invoiceFormat !== undefined && detail.invoiceFormat !== '' ? String(detail.invoiceFormat) : '0';
          this.from.SendingMode = detail.sendType !== undefined ? Number(detail.sendType) : 2;
          this.from.mailbox = detail.mail || '';
          this.from.Note = detail.remark || '';
          this.from.quantity = detail.invoiceQuantity !== undefined ? detail.invoiceQuantity : '1';
          this.from.reissueReason = detail.reissueReason || '';

          console.log('开票信息回显后:', this.from);
        } else {
          this.SwitchIsItOptional = true;
        }
      },
      immediate: false,
    },
    // // 监听
    dialogIssue: {
      handler(newSs, old) {
        if (newSs == true) {
          this.from.EnterpriseType = this.seller.companyType;
          this.from.PayTaxesType = this.seller.taxType;
          this.from.address = this.seller.sellerCompanyAddress;
          this.from.phone = this.seller.sellerPhone;

          if (
            this.seller.companyType !== null &&
            this.seller.companyType !== ""
          ) {
            // 自动选中企业类型，不可在修改
            this.EnterpriseIsItOptional = false;
          }
          if (this.seller.taxType !== null && this.seller.taxType !== "") {
            // 自动选中纳税类型，不可在修改
            this.PayTaxesIsItOptional = false;
          }
        } else {
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          this.SwitchIsItOptional = true;
          this.ResetFrom();
        }
      },
      immediate: false,
    },

    // // 监听 开票信息
    "from.Message": {
      handler(newSs, old) {
        this.companyInvoiceCalculatePrice();
      },
      immediate: false,
    },
  },

  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // 重置from
    ResetFrom() {
      this.from.Purchaser = ""; //购买方
      this.from.PurchaserId = ""; // 购买方id
      this.from.PurchaserName = ""; //购买方法人
      this.from.PurchaserCode = ""; //购买方统一代码
      this.from.IdentityCard = ""; //身份证
      this.from.PurchaserPhone = ""; //购买方联系电话
      this.from.customerCompanyType = ""; //购买方企业类型
      this.from.PurchaseBankName = ""; //购买方开户银行名称
      this.from.PurchaseAccount = ""; //购买方开户账号
      this.from.PurchaseAddress = ""; //购买方地址

      // this.from.EnterpriseType = null; //企业类型
      // this.from.PayTaxesType = null; //纳税类型
      this.from.bank = ""; //开户行
      this.from.AccountNumber = ""; //基本开户账号
      // this.from.address = ""; //住所
      // this.from.phone = ""; //固定电话
      this.from.PurchaseShowHide = 1; //购买方信息展示/隐藏
      this.from.SalesShowHide = 1; //销售方信息展示/隐藏
      this.from.Message = ""; //开票信息
      this.from.quantity = "1"; //开票数量
      this.from.nature = "0"; //发票类型 0普票1专票
      this.from.format = "0"; // 开票格式
      this.from.SendingMode = 2; // 发送方式
      this.from.mailbox = ""; //邮箱地址
      this.from.Note = ""; //备注
      this.from.reissueReason = ""; //重开说明

      this.from.numBean = "";

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 500);
    },
    handelSwitch(item) {
      this.ResetFrom();

      this.Switch = item;
    },
    //选择购买方
    handelChange(val) {
      for (var i in this.options) {
        if (this.options[i].companyName == val) {
          this.from.PurchaserCode = this.options[i].customerCreditCode;
          this.from.PurchaserPhone = this.options[i].phone;
          this.from.PurchaserId = this.options[i].id;
          this.from.PurchaserName = this.options[i].legalPerson;
          this.from.customerCompanyType = this.options[i].customerCompanyType;
          this.from.PurchaseBankName = this.options[i].customerBankName;
          this.from.PurchaseAccount = this.options[i].customerBankAccount;
          this.from.PurchaseAddress = this.options[i].customerCompanyAddress;
          // 防止选择购买方后带出信用代码等数据了但表单验证的报错仍然存在
          // this.handleVerifyIssue("ruleForm");
          this.$refs.ruleForm.clearValidate();
          this.companyInvoiceCalculatePrice();
        }
      }
    },
    //计算代开发票需要消耗的发票豆
    companyInvoiceCalculatePrice() {
      // 把需要校验的字段名放到数组里
      const requiredFields = [
        "EnterpriseType",
        "PayTaxesType",
        "Message",
        "quantity",
        "nature",
        "format",
        "SendingMode",
      ];

      // 检查所有字段都不为空串和 null
      const allValid = requiredFields.every(
        (field) => this.from[field] !== "" && this.from[field] !== null
      );
      if (allValid) {
        var data = {
          data: {
            companyType: this.from.EnterpriseType, //企业类型
            taxType: this.from.PayTaxesType, //纳税人类型
            headType: this.Switch, //0自然人  1企业
            itemCalculateList:
              this.Switch == 1
                ? [
                    {
                      invoiceQuantity: this.from.quantity, //开票数量
                      invoiceAttr: this.from.nature, //发票类型 0普票1专票
                      businessInfo: this.from.Message, //开票信息
                      invoiceFormat: this.from.format, //发票格式
                      sendType: this.from.SendingMode, //发送方式
                      mail: this.from.mailbox, //邮箱
                      remark: this.from.Note, //备注
                    },
                  ]
                : [
                    {
                      invoiceQuantity: this.from.quantity, //发票数量
                      invoiceAttr: this.from.nature, //发票类型 0普票1专票
                      businessInfo: this.from.Message, //开票信息
                      invoiceFormat: this.from.format, //发票格式
                      sendType: this.from.SendingMode, //发送方式
                      mail: this.from.mailbox, //邮箱
                      remark: this.from.Note, //备注
                      customerName: this.from.Purchaser, //姓名
                      customerCreditCode: this.from.IdentityCard, //身份证号
                      customerPhone: this.from.PurchaserPhone, //手机号
                      customerBankName: this.from.PurchaseBankName, //开户行
                      customerBankAccount: this.from.PurchaseAccount, //账户
                      customerCompanyAddress: this.from.PurchaseAddress, //地址
                      showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
                    },
                  ], //开票信息
          },
        };
        API.companyInvoiceCalculatePrice(data).then((res) => {
          if (res.code == 0) {
            this.from.numBean = res.data;
            this.$refs.ruleForm.validateField("numBean");
          }
        });
      }
    },
    // 单选发送方式
    handelSend(item) {
      this.from.SendingMode = item.id;
    },
    onSendChange() {
      this.companyInvoiceCalculatePrice();
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("SendingMode");
    },
    onEnterpriseTypeChange() {
      this.companyInvoiceCalculatePrice();
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("EnterpriseType");
    },
    onPayTaxesTypeChange() {
      this.companyInvoiceCalculatePrice();
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("PayTaxesType");
    },
    onNatureChange() {
      this.companyInvoiceCalculatePrice();
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("nature");
    },
    onFormatChange() {
      this.companyInvoiceCalculatePrice();
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("format");
    },

    //单选 发票类型（普票/专票）
    handelSingleChoice(item) {
      this.from.nature = item.id;
    },
    // 单选 开票格式
    handelFormat(item) {
      this.from.format = item.id;
    },
    // 取消
    handleIssue() {
      this.$emit("handleIssue", this.type);
    },
    // 数量选择
    handleChange(value) {
      this.companyInvoiceCalculatePrice();
      console.log(value);
    },
    handleUnderstandPwd(pwd) {
      if (this.Switch == 1) {
        var data = {
          data: {
            businessType: "PROXY_INVOICE",
            password: pwd,
            businessInfo: {
              customerBankName: this.from.PurchaseBankName,
              customerBankAccount: this.from.PurchaseAccount,
              customerName: this.from.Purchaser, //客户名
              customerLegalPerson: this.from.PurchaserName, //客户法人
              customerCreditCode: this.from.PurchaserCode, //客户统一代码
              customerPhone: this.from.PurchaserPhone, //客户手机号
              customerCompanyType: this.from.customerCompanyType,
              customerCompanyAddress: this.from.PurchaseAddress, //客戶地址
              showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
              sellerTaxType: this.from.PayTaxesType, //销售方纳税类型
              sellerCompanyType: this.from.EnterpriseType, //销售方企业类型
              reissueId: this.reissueId, //重开发票ID
              reissueReason: this.from.reissueReason, //重开说明
              sellerBankName: this.from.bank, //销售方开户行名称
              sellerBankAccount: this.from.AccountNumber, //销售方开户行账号
              sellerCompanyAddress: this.from.address, //销售方住所
              sellerPhone: this.from.phone, //销售方手机号
              showSellerInfo: this.from.SalesShowHide, //是否展示销售放信息
              invoiceItemDtoList: [
                {
                  invoiceQuantity: this.from.quantity, //发票数量
                  invoiceAttr: this.from.nature, //发票类型 0普票1专票
                  businessInfo: this.from.Message, //开票信息
                  invoiceFormat: this.from.format, //发票格式
                  sendType: this.from.SendingMode, //发送方式
                  mail: this.from.mailbox, //邮箱
                  remark: this.from.Note, //备注
                },
              ],
              price: this.from.numBean,
            },
            payMethod: "INVOICE_BEANS_PAY",
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleVerifyIssue");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(3);
          }
        });
      } else {
        // 开给自然人
        var data = {
          data: {
            businessType: "PROXY_PERSON_INVOICE",
            payMethod: "INVOICE_BEANS_PAY",
            password: pwd,
            businessInfo: {
              sellerTaxType: this.from.PayTaxesType, //销售方纳税类型
              sellerCompanyType: this.from.EnterpriseType, //销售方企业类型
              sellerBankName: this.from.bank, //销售方开户行名称
              sellerBankAccount: this.from.AccountNumber, //销售方开户行账号
              sellerCompanyAddress: this.from.address, //销售方住所
              sellerPhone: this.from.phone, //销售方手机号
              showSellerInfo: this.from.SalesShowHide, //是否展示销售放信息
              price: this.from.numBean, //总价格
              reissueId: this.reissueId, //重开发票ID
              reissueReason: this.from.reissueReason, //重开说明

              invoiceItemDtoList: [
                {
                  invoiceQuantity: this.from.quantity, //发票数量
                  invoiceAttr: this.from.nature, //发票类型 0普票1专票
                  businessInfo: this.from.Message, //开票信息
                  invoiceFormat: this.from.format, //发票格式
                  sendType: this.from.SendingMode, //发送方式
                  mail: this.from.mailbox, //邮箱
                  remark: this.from.Note, //备注
                  customerName: this.from.Purchaser, //姓名
                  customerCreditCode: this.from.IdentityCard, //身份证号
                  customerPhone: this.from.PurchaserPhone, //手机号
                  customerBankName: this.from.PurchaseBankName, //开户行
                  customerBankAccount: this.from.PurchaseAccount, //账户
                  customerCompanyAddress: this.from.PurchaseAddress, //地址
                  showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
                },
              ],
            },
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleVerifyIssue");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(0, 4);
          }
        });
      }
    },
    //确认
    handleVerifyIssue() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        if (this.reissueId && !String(this.from.reissueReason || "").trim()) {
          this.$tool.PromptBox("warning", "请填写重开说明");
          return false;
        }
        if (localStorage.getItem("PaymentPwd") == "false") {
          //没有开启支付密码验证直接弹支付二维码
          this.handleUnderstandPwd();
        } else {
          // 支付密码验证
          this.VisiblePwd = true;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.Select-Con {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 0 0 24px;
  border-bottom: 1px solid #edeff2;
  .Options {
    min-width: 96px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    margin: 0 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    font-size: 14px;
    color: #666666;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
  }
  .Select {
    color: #409eff;
    background: transparent;
    border-bottom: 2px solid #409eff;
  }
}

.main-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;

  .section-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  .section-block {
    box-sizing: border-box;
    min-width: 0;
  }
  .section-buyer,
  .section-seller {
    flex: 1 1 0;
    width: 0;
    max-width: 50%;
  }
  .section-buyer {
    padding-right: 24px;
  }
  .section-seller {
    padding-left: 24px;
    border-left: 1px solid #edeff2;
  }
  .section-service {
    margin-top: 8px;
    padding-top: 20px;
    border-top: 1px solid #edeff2;
  }
  .invoice-meta-row {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 2px;
    gap: 32px;
  }
  .section-title {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 22px;
    text-align: center;
  }
  .Reminder {
    width: 100%;
    margin-top: 6px;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }
  .is-hidden-item {
    display: none !important;
  }
  .quantity-text {
    color: #303133;
    font-size: 14px;
  }
  .consume-text {
    color: #fe574a;
    font-size: 14px;
    line-height: 36px;
  }
  .mailbox {
    width: 360px !important;
    max-width: 100% !important;
  }
}

/* Element 内部节点需穿透；收拢到表单根类下，避免重复 /deep/ */
.invoice-info-form {
  /deep/ .el-form-item {
    margin-bottom: 5px !important;
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  /deep/ .el-form-item__label {
    white-space: nowrap !important;
    padding-right: 8px !important;
    float: none !important;
    width: auto !important;
    flex: 0 0 148px;
    text-align: right;
    line-height: 36px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
    line-height: 36px;
    width: auto !important;
    flex: 1 1 auto !important;
    min-width: 0;
    position: relative;
    padding-bottom: 20px; /* 始终预留校验行 */
  }
  /deep/ .el-form-item__error {
    position: absolute !important;
    top: auto !important; /* 覆盖 Element 默认 top:100%，避免压到下一行 */
    left: 0 !important;
    bottom: 2px !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    line-height: 16px;
    z-index: 2;
  }
  /deep/ .el-textarea ~ .el-form-item__error {
    position: absolute !important;
    top: auto !important;
    left: 0 !important;
    bottom: 2px !important;
    margin-top: 0 !important;
    line-height: 16px;
  }
  /deep/ .Instruction .el-form-item__error {
    margin-top: 0 !important;
  }
  /deep/ .el-form-item.is-error .el-input__inner,
  /deep/ .el-form-item.is-error textarea {
    border-color: #fe574a !important;
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: 360px !important;
    max-width: 100% !important;
    height: 36px !important;
  }
  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    width: 100% !important;
    height: 36px !important;
    line-height: 36px !important;
  }
  /deep/ .el-select .el-input__icon {
    line-height: 36px !important;
  }
  /deep/ .el-textarea {
    width: 360px !important;
    max-width: 100% !important;
  }
  /deep/ .textarea-lg {
    width: 900px !important;
    max-width: 100% !important;
  }
  /deep/ .textarea-lg .el-textarea__inner {
    min-height: 120px !important;
    height: 120px !important;
    line-height: 22px !important;
    padding: 10px 12px !important;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff !important;
    color: #606266 !important;
    -webkit-text-fill-color: #606266 !important;
    border-color: #409eff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
  }
  /deep/ .el-radio-group {
    display: inline-flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    vertical-align: middle;
    max-width: 100%;
    line-height: 36px;
  }
  /deep/ .el-radio {
    margin-right: 10px;
    margin-bottom: 0;
    line-height: 22px;
    white-space: nowrap;
  }
  /deep/ .el-radio__label {
    font-size: 13px;
    color: #333333;
    padding-left: 4px;
  }
  
  .invoice-meta-row {
    /deep/ .el-form-item {
      margin-bottom: 5px !important;
      margin-right: 28px;
      width: auto;
      flex: 0 0 auto;
    }
    /deep/ .el-form-item__label {
      flex: 0 0 auto;
      width: auto !important;
      padding-right: 6px !important;
    }
    /deep/ .meta-quantity .el-form-item__label,
    /deep/ .meta-send .el-form-item__label {
      flex: 0 0 148px;
    }
    /deep/ .el-form-item__content {
      flex: 0 0 auto;
      margin-right: 24px;
      padding-bottom: 20px;
    }
    /deep/ .el-radio {
      margin-right: 12px;
    }
  }
}
</style>
